import { KEY } from './constants'

export const SET_MODAL = `${KEY}/SET_MODAL`
